// ActivityFeed — renders the property's recent_activity events.
import {
  UserPlus,
  UserMinus,
  FileText,
  Wrench,
  CheckCircle2,
  AlertOctagon,
  FileSignature,
  FileX2,
  Pencil,
} from "lucide-react";

const ICONS = {
  tenant_added: { Icon: UserPlus, tone: "text-emerald-600 bg-emerald-50" },
  tenant_updated: { Icon: Pencil, tone: "text-slate-600 bg-slate-50" },
  tenant_removed: { Icon: UserMinus, tone: "text-red-600 bg-red-50" },
  lease_drafted: { Icon: FileText, tone: "text-indigo-600 bg-indigo-50" },
  lease_activated: { Icon: FileSignature, tone: "text-emerald-600 bg-emerald-50" },
  lease_updated: { Icon: Pencil, tone: "text-slate-600 bg-slate-50" },
  lease_terminated: { Icon: FileX2, tone: "text-red-600 bg-red-50" },
  maintenance_opened: { Icon: AlertOctagon, tone: "text-amber-600 bg-amber-50" },
  maintenance_updated: { Icon: Wrench, tone: "text-slate-600 bg-slate-50" },
  maintenance_resolved: { Icon: CheckCircle2, tone: "text-emerald-600 bg-emerald-50" },
  document_uploaded: { Icon: FileText, tone: "text-indigo-600 bg-indigo-50" },
  document_deleted: { Icon: FileX2, tone: "text-red-600 bg-red-50" },
};

function relativeTime(iso) {
  if (!iso) return "";
  const dt = new Date(iso);
  const delta = Math.floor((Date.now() - dt.getTime()) / 1000);
  if (delta < 60) return "just now";
  if (delta < 3600) return `${Math.floor(delta / 60)}m ago`;
  if (delta < 86400) return `${Math.floor(delta / 3600)}h ago`;
  if (delta < 604800) return `${Math.floor(delta / 86400)}d ago`;
  return dt.toLocaleDateString();
}

export default function ActivityFeed({ events }) {
  if (!events || events.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-slate-200 bg-slate-50/50 p-6 text-center text-sm text-slate-500" data-testid="activity-feed-empty">
        Nothing happening yet. As you add tenants, leases, and maintenance, the activity stream will appear here.
      </div>
    );
  }

  return (
    <ol className="space-y-3" data-testid="activity-feed">
      {events.map((e) => {
        const { Icon = FileText, tone = "text-slate-600 bg-slate-50" } = ICONS[e.type] || {};
        return (
          <li key={e.id} className="flex items-start gap-3" data-testid={`activity-${e.type}`}>
            <span className={`mt-0.5 inline-flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full ${tone}`}>
              <Icon className="h-3.5 w-3.5" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-slate-900">{e.title}</p>
              {e.detail && <p className="text-xs text-slate-500">{e.detail}</p>}
              <p className="text-[11px] text-slate-400">{relativeTime(e.created_at)}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
